module.exports = __webpack_public_path__ + "img/ellipse.5d2931d6.svg";